module.exports = __webpack_public_path__ + "media/images/bi-sort-alpha-up-745c6ccd.svg";